import { Routes } from '@angular/router'; 
import { LoginComponent } from './login.component'; 
import { OtpComponent } from './otp.component'; 
import { ActivateComponent } from './activate.component';
import { ForgotPasswordComponent } from './forgot-password.component';
import { ResetPasswordComponent } from './reset-password.component';
import { CustomerDeclarationComponent } from './customer-declaration.component';
import { CustomerQuoteComponent } from './customer-quote.component';
import { CustomerFeedbackComponent } from './customer-feedback.component';
import { CustomerInvoiceComponent } from './customer-invoice.component';
import { AdminLayoutComponent } from './admin-layout.component';
import { AdminDashboardComponent } from './admin-dashboard.component';
import { AdminDispatchUnassignedComponent } from './admin-dispatch-unassigned.component';
import { AdminDispatchAllocatedComponent } from './admin-dispatch-allocated.component';
import { AdminDispatchReadyComponent } from './admin-dispatch-ready.component';
import { AdminJobsControlComponent } from './admin-jobs-control.component';
import { AdminWorkerMapComponent } from './admin-worker-map.component';
import { AdminJobDetailComponent } from './admin-job-detail.component';
import { AdminArchivedJobsComponent } from './admin-archived-jobs.component';
import { AdminQuotesListComponent } from './admin-quotes-list.component';
import { AdminQuoteDetailComponent } from './admin-quote-detail.component';
import { AdminPurchaseOrdersComponent } from './admin-purchase-orders.component';
import { AdminPurchaseOrderDetailComponent } from './admin-purchase-order-detail.component';
import { AdminPurchaseOrderSuppliersComponent } from './admin-purchase-order-suppliers.component';
import { AdminPurchaseOrderTemplatesComponent } from './admin-purchase-order-templates.component';
import { AdminPurchaseOrderReportsComponent } from './admin-purchase-order-reports.component';
import { AdminWorkOrdersComponent } from './admin-work-orders.component';
import { AdminWorkOrderDetailComponent } from './admin-work-order-detail.component';
import { AdminSettingsComponent } from './admin-settings.component';
import { AdminMaterialsComponent } from './admin-materials.component';
import { AdminDocumentsComponent } from './admin-documents.component';
import { AdminDocumentFolderComponent } from './admin-document-folder.component';
import { AdminComplianceStaffComponent } from './admin-compliance-staff.component';
import { AdminComplianceVisasComponent } from './admin-compliance-visas.component';
import { AdminComplianceFleetComponent } from './admin-compliance-fleet.component';
import { AdminComplianceAuditsComponent } from './admin-compliance-audits.component';
import { AdminTimesheetComponent } from './admin-timesheet.component';
import { AdminStaffCalendarComponent } from './admin-staff-calendar.component';
import { AdminNotificationCenterComponent } from './admin-notification-center.component';
import { AdminNotificationControlsComponent } from './admin-notification-controls.component';
import { AdminOperationsReportComponent } from './admin-operations-report.component';
import { AdminLeaveRequestsComponent } from './admin-leave-requests.component';
import { AdminLeaveRequestDetailComponent } from './admin-leave-request-detail.component';
import { AdminCustomersComponent } from './admin-customers.component';
import { AdminCustomerFeedbackComponent } from './admin-customer-feedback.component';
import { AdminProjectsListComponent } from './admin-projects-list.component';
import { AdminProjectDetailComponent } from './admin-project-detail.component';
import { authChildGuard, authGuard, guestGuard, landingGuard, officeArchiveGuard } from './auth.guard';
import { AdminInsuranceDocComponent } from './admin-insurance-doc.component';
import { AdminInsuranceDashboardComponent } from './admin-insurance-dashboard.component';
import { AdminAsBuiltDashboardComponent } from './admin-as-built-dashboard.component';
import { AdminAsBuiltDocComponent } from './admin-as-built-doc.component';
import { AdminAsBuiltTrainingComponent } from './admin-as-built-training.component';
import { AdminAsBuiltTrainingSessionComponent } from './admin-as-built-training-session.component';
import { AdminProjectPdfViewerComponent } from './admin-project-pdf-viewer.component';
import { AdminProjectDocumentViewerComponent } from './admin-project-document-viewer.component';
import { AdminProfileComponent } from './admin-profile.component';
import { PublicLeaveReviewComponent } from './public-leave-review.component';
import { AdminPdfCompressorComponent } from './admin-pdf-compressor.component';

export const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [landingGuard], pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [guestGuard] },
  { path: 'otp', component: OtpComponent },
  { path: 'activate', component: ActivateComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'declaration/:id', component: CustomerDeclarationComponent },
  { path: 'declaration-pdf/:id', component: AdminProjectPdfViewerComponent, data: { docType: 'declaration', publicBack: true } },
  { path: 'quote/:token', component: CustomerQuoteComponent },
  { path: 'feedback/:token', component: CustomerFeedbackComponent },
  { path: 'leave-review/:token', component: PublicLeaveReviewComponent },
  { path: 'invoice/:token', component: CustomerInvoiceComponent },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: AdminDashboardComponent },
      { path: 'notifications', component: AdminNotificationCenterComponent },
      { path: 'notification-controls', component: AdminNotificationControlsComponent },
      { path: 'profile', component: AdminProfileComponent },
      { path: 'customers', component: AdminCustomersComponent },
      { path: 'customer-feedback', component: AdminCustomerFeedbackComponent },
      { 
        path: 'dispatch', 
        children: [
          { path: '', redirectTo: 'control', pathMatch: 'full' },
          { path: 'control', component: AdminJobsControlComponent },
          { path: 'unassigned', component: AdminDispatchUnassignedComponent },
          { path: 'allocated', component: AdminDispatchAllocatedComponent },
          { path: 'worker-map', component: AdminWorkerMapComponent },
          { path: 'ready', component: AdminDispatchReadyComponent },
          { path: 'archived', component: AdminArchivedJobsComponent, canActivate: [officeArchiveGuard] },
          { path: 'job/:id', component: AdminJobDetailComponent }
        ]
      },
      {
        path: 'projects',
        children: [
          { path: '', component: AdminProjectsListComponent, pathMatch: 'full' },
          { path: 'stage/:stageId', component: AdminProjectsListComponent },
          { path: ':id', component: AdminProjectDetailComponent }
        ]
      },
      {
        path: 'forms/:type',
        loadComponent: () => import('./admin-forms-launcher.component').then(module => module.AdminFormsLauncherComponent)
      },
      {
        path: 'financials',
        children: [
          { path: '', redirectTo: 'quotes', pathMatch: 'full' },
          { path: 'quotes', component: AdminQuotesListComponent },
          { path: 'quotes/:id', component: AdminQuoteDetailComponent },
          { path: 'purchase-orders', component: AdminPurchaseOrdersComponent },
          { path: 'purchase-orders/new', component: AdminPurchaseOrderDetailComponent },
          { path: 'purchase-orders/suppliers', component: AdminPurchaseOrderSuppliersComponent },
          { path: 'purchase-orders/templates', component: AdminPurchaseOrderTemplatesComponent },
          { path: 'purchase-orders/reports', component: AdminPurchaseOrderReportsComponent },
          { path: 'purchase-orders/:id', component: AdminPurchaseOrderDetailComponent },
          { path: 'work-orders', component: AdminWorkOrdersComponent },
          { path: 'work-orders/new', component: AdminWorkOrderDetailComponent },
          { path: 'work-orders/:id', component: AdminWorkOrderDetailComponent },
          { path: 'invoices', redirectTo: 'quotes', pathMatch: 'full' },
          { path: 'invoices/:id', redirectTo: 'quotes' },
          { path: 'pdf/:docType/:id', component: AdminProjectPdfViewerComponent },
          { path: 'materials', component: AdminMaterialsComponent },
        ]
      },
      { path: 'insurance', redirectTo: 'ai/insurance', pathMatch: 'full' },
      { path: 'documents', component: AdminDocumentsComponent },
      { path: 'tools/compress-pdf', component: AdminPdfCompressorComponent },
      { path: 'timesheet', component: AdminTimesheetComponent },
      { path: 'reports/operations', component: AdminOperationsReportComponent },
      { path: 'leave-requests', component: AdminLeaveRequestsComponent },
      { path: 'leave-requests/:id', component: AdminLeaveRequestDetailComponent },
      {
        path: 'operations',
        children: [
          { path: '', redirectTo: 'report', pathMatch: 'full' },
          { path: 'report', component: AdminOperationsReportComponent },
          { path: 'calendar', component: AdminStaffCalendarComponent },
          { path: 'staff', component: AdminComplianceStaffComponent },
          { path: 'timesheet', component: AdminTimesheetComponent },
          { path: 'leave-requests', component: AdminLeaveRequestsComponent },
          { path: 'leave-requests/:id', component: AdminLeaveRequestDetailComponent },
          { path: 'workers-control', component: AdminWorkerMapComponent },
          { path: 'worker-map', component: AdminWorkerMapComponent },
          { path: 'fleet', component: AdminComplianceFleetComponent },
        ]
      },
      { path: 'documents/:id', component: AdminDocumentFolderComponent },
      { path: 'settings', component: AdminSettingsComponent },
      { path: 'ai/insurance', component: AdminInsuranceDashboardComponent },
      { path: 'ai/insurance/:id', component: AdminInsuranceDocComponent },
      { path: 'ai/as-built', component: AdminAsBuiltDashboardComponent },
      { path: 'ai/as-built/training/session/:sessionId', component: AdminAsBuiltTrainingSessionComponent },
      { path: 'ai/as-built/training', component: AdminAsBuiltTrainingComponent },
      { path: 'ai/as-built/:id', component: AdminAsBuiltDocComponent },
      { path: 'project-pdf/:docType/:id', component: AdminProjectPdfViewerComponent },
      { path: 'project-doc/:id', component: AdminProjectDocumentViewerComponent },
      {
        path: 'compliance',
        children: [
          { path: '', redirectTo: 'staff', pathMatch: 'full' },
          { path: 'staff', component: AdminComplianceStaffComponent },
          { path: 'timesheet', component: AdminTimesheetComponent },
          { path: 'reports', component: AdminOperationsReportComponent },
          { path: 'visas', component: AdminComplianceVisasComponent },
          { path: 'fleet', component: AdminComplianceFleetComponent },
          { path: 'audits', component: AdminComplianceAuditsComponent },
        ]
      },
    ]
  },
  { path: '**', redirectTo: '/login' }
];
